import { render, staticRenderFns } from "./viewTransport.vue?vue&type=template&id=72049b00&"
import script from "./viewTransport.vue?vue&type=script&lang=js&"
export * from "./viewTransport.vue?vue&type=script&lang=js&"
import style0 from "./viewTransport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports